export default __webpack_public_path__ + "static/media/icon-2.ee82a7a2.png";